import { getResizedImage } from 'shared-helpers/common';
import { useAchievementTypes, useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { AchievementIcon } from 'components/achievements';
import { DisplayFormattedDate, LoadingIndicator } from 'components/common';
import { HomeDetailsItem } from '.';

import type { GetUserExpiringCompletionsRes } from 'shared-types/responses';

const HomeDetailsExpiringCompletions = () => {
  const { messages, theme, user } = useReduxState();

  const achievementTypes = useAchievementTypes();

  const { data, loading } = useApiData<GetUserExpiringCompletionsRes>({
    url: `/admin/users/${user?.id}/expiring-completions`
  });

  return loading ? (
    <LoadingIndicator />
  ) : (
    <div className="completions">
      {data?.completions.map((completion) => (
        <HomeDetailsItem
          href={
            completion.type === 'course'
              ? completion.course.slug
                ? `/courses/${completion.course.slug}`
                : ''
              : completion.type === 'achievement'
              ? `/achievements/${completion.achievement.id}`
              : ''
          }
          key={completion.id}
          category="warning-light"
          timePrefix={messages.commonExpires}
          timeString={completion.expirationDate as string}
        >
          {completion.type === 'course' ? (
            <div
              className="course-picture"
              style={{
                backgroundImage: `url(${getResizedImage({
                  url: completion.course.picture,
                  size: 480
                })})`,
                backgroundPosition: completion.course.picturePosition
              }}
            />
          ) : completion.type === 'achievement' ? (
            <AchievementIcon type={completion.achievement.type} />
          ) : null}
          <div className="inner">
            <div className="title">
              {completion.type === 'course'
                ? completion.course.title
                : completion.type === 'achievement'
                ? completion.achievement.title
                : ''}
            </div>
            <div className="info">
              {completion.type === 'course' ? (
                <div>{messages.commonCourse}</div>
              ) : completion.type === 'achievement' ? (
                <div>{achievementTypes[completion.achievement.type].title}</div>
              ) : null}

              <div className="completed">
                <span>{`${messages.completionsCompletionDate}: `}</span>
                <span>
                  <DisplayFormattedDate date={completion.completionDate} />
                </span>
              </div>

              <div className="expires">
                <span>{`${messages.commonExpirationDate}: `}</span>
                <span>
                  <DisplayFormattedDate date={completion.expirationDate} />
                </span>
              </div>
            </div>
          </div>
        </HomeDetailsItem>
      ))}

      <style jsx>{`
        .completions {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
        .course-picture {
          background-color: ${theme.lightGrey};
          background-size: cover;
          border-radius: 8px;
          flex-shrink: 0;
          height: 40px;
          width: 40px;
        }
        .inner {
          flex-grow: 1;
        }
        .title {
          font-size: 1.6rem;
          font-weight: 700;
        }
        .info {
          color: ${theme.textColorLighter};
          display: flex;
          flex-wrap: wrap;
          font-size: 1.4rem;
          font-weight: 600;
          gap: 5px 40px;
          margin-top: 4px;
        }
        .completed {
          color: ${theme.successStandaloneColor};
        }
        .expires {
          color: ${theme.dangerColor};
        }
      `}</style>
    </div>
  );
};
export default HomeDetailsExpiringCompletions;
